export const formatNumber = function (value, decimals = -1) {
  if (!decimals) {
    decimals = 0
  }

  if (decimals === -1) {
    const val = (value / 1).toFixed(1).replace('.', ',')
    return val.toString().replace(',0', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  const val = (value / 1).toFixed(decimals).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}



// WEBPACK FOOTER //
// ./src/helpers/format-number.js